import { gql } from '@apollo/client';

export const GET_CONTRACTS_FOR_LIST = gql`
  query GetContractsForList($input: ContractFilterInput) {
    contracts(filterInput: $input) {
      items {
        id
        rentAmount
        startDate
        finishDate
        monthlyChargeAmount
        isAutoGenerateRentCharges
        unities {
          name
        }
        property {
          id
          name
        }
        tenant {
          firstName
          lastName
          user {
            id
          }
        }
        statusOption
        signed
      }
      pagination {
        totalItems
        totalPages
        currentPage
        pageSize
        hasNextPage
        hasPreviousPage
      }
    }
  }
`;
